export default __webpack_public_path__ + "static/media/total_mount.547bfd20.svg";